(() => {
  const API_KEY = '__biceekFaq';

  if (window[API_KEY]) {
    window[API_KEY].refresh();
    return;
  }

  const controllers = new Map();

  class FaqController {
    constructor(root) {
      this.root = root;
      this.details = Array.from(root.querySelectorAll('.bf-accordion'));
      this.abortController = new AbortController();
      this.mount();
    }

    mount() {
      if (this.root.dataset.bfSingleOpen !== 'true') return;

      const {signal} = this.abortController;
      this.details.forEach((item) => {
        item.addEventListener(
          'toggle',
          () => {
            if (!item.open) return;
            this.details.forEach((otherItem) => {
              if (otherItem !== item) otherItem.open = false;
            });
          },
          {signal},
        );
      });
    }

    destroy() {
      this.abortController.abort();
    }
  }

  function refresh() {
    const roots = new Set(document.querySelectorAll('[data-bf-faq]'));

    controllers.forEach((controller, root) => {
      if (!roots.has(root)) {
        controller.destroy();
        controllers.delete(root);
      }
    });

    roots.forEach((root) => {
      controllers.get(root)?.destroy();
      controllers.set(root, new FaqController(root));
    });
  }

  function removeWithin(scope) {
    controllers.forEach((controller, root) => {
      if (scope.contains(root) || root === scope) {
        controller.destroy();
        controllers.delete(root);
      }
    });
  }

  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', (event) => removeWithin(event.target));

  window[API_KEY] = {refresh};

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh, {once: true});
  } else {
    refresh();
  }
})();
